/**
 * What the API grants a role on a module, read the way the API reads it
 * (rbac.user_has_permission): the module's own entry wins over "All modules",
 * including when it grants less, and a governed resource ignores "All modules".
 * The Role Permissions grid used to OR the two, so a narrowed module still
 * showed every box ticked, and Database Console looked granted wherever
 * "All modules" was.
 */
export function grantedActions(
  spec: Record<string, string[]>,
  moduleId: string,
  governed: ReadonlySet<string>,
): string[] {
  const own = spec[moduleId]
  if (Array.isArray(own)) return own
  if (governed.has(moduleId)) return []
  return spec['*'] ?? []
}
